var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1261157341"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43104 11.8734C8.92928 10.3493 11.262 9.34452 12.4292 8.85905C15.7617 7.47294 16.4542 7.23216 16.9055 7.22421C17.0048 7.22246 17.2267 7.24706 17.3705 7.36372C17.4919 7.46223 17.5253 7.5953 17.5413 7.6887C17.5573 7.78209 17.5772 7.99485 17.5614 8.1611C17.3808 10.0586 16.5994 14.6633 16.2018 16.7885C16.0336 17.6877 15.7024 17.9892 15.3817 18.0188C14.6849 18.0829 14.1557 17.5582 13.4808 17.1158C12.4246 16.4235 11.8279 15.9925 10.8028 15.3169C9.61798 14.5362 10.386 14.107 11.0612 13.4058C11.2379 13.2222 14.3083 10.4295 14.3677 10.1761C14.3752 10.1444 14.3821 10.0263 14.3119 9.96397C14.2417 9.9016 14.1382 9.92293 14.0635 9.93989C13.9575 9.96393 12.2703 11.0791 9.00179 13.2855C8.52287 13.6143 8.08909 13.7746 7.70043 13.7662C7.27197 13.7569 6.44778 13.5239 5.83508 13.3247C5.08358 13.0804 4.4863 12.9513 4.53831 12.5364C4.5654 12.3203 4.86298 12.0993 5.43104 11.8734Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegramIcon.8284a0dcf69f97aa1e590e2dcff18f4e.svg";
export { ForwardRef as ReactComponent };